import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedstate  from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    formDataList: [], //我的申请
    formProcessList: [],  //待我处理
    formRelatedList: [],  //我的相关
  },
  mutations: {
    SET_FORMDATALIST(state, value) {
      state.formDataList = value
      // Vue.set(state.formDataList,value)
    },
    SET_FORMPROCESSLIST(state, value) {
      state.formProcessList = value
    },
    SET_FORMRELATEDLIST(state, value) {
      state.formRelatedList = value
    },
  },
  actions: {
    
  },
  modules: {
  },
  plugins: [
    // 数据持久化设置
    createPersistedstate({
      key: 'user', //存数据的key名，自定义
      // paths: ['formDataList'],  //要把哪些模块加入缓存 
    })
  ]
})
